import React from 'react';

// Components
import ToolbarTool from '../../../ToolbarTool';
import Icon from '../../../../../../components/icons/Icon';

// Utils
import { isSelectingSingleSelectionAndCell } from '../../../../../../element/table/utils/tableCellSelectionUtils';
import { addHotTableFormulaToCell } from '../../../../../../element/table/utils/hotInstanceUtils/hotTableCellFormulaUtils';

// Selectors
import {
    useLegacyActiveTableCallback,
    useLegacyActiveTableSelector,
} from '../../../../../../element/table/store/legacyHotTableStoreHooks';
import { selectLegacyActiveTableCellSelection } from '../../../../../../element/table/store/selectors/legacyActiveHotTableSelectors';

const LegacyTableCellFormulaTool: React.FC = (props) => {
    const currentCellSelections = useLegacyActiveTableSelector(selectLegacyActiveTableCellSelection);

    const triggerFormula = useLegacyActiveTableCallback((activeTable) => addHotTableFormulaToCell(activeTable), []);

    return (
        <div className="TableCellFormulaTool LegacyTableCellFormulaTool">
            <ToolbarTool
                {...props}
                onClick={triggerFormula}
                isActive={false}
                disabled={!isSelectingSingleSelectionAndCell(currentCellSelections)}
            >
                <Icon name="toolbar-formula" />
            </ToolbarTool>
        </div>
    );
};

export default LegacyTableCellFormulaTool;
